let notch = 0
let oldVal = -1

// 硬件转软件协议
function hardwareToSoft(id, value, type) {
  if (type !== 1) {
    // 车钟消息处理
    if (type === 5) {
      let data = notchToSoft(id, value)
      return data
    }
    return null
  }
}

// 车钟转软件协议（优化无极旋钮边界判断）
function notchToSoft(id, value) {
  if (id !== 2) return null

  // 初始化旧值
  if (oldVal < 0) {
    oldVal = value
    return { value: notch }
  }

  const maxVal = 1022 // 无极旋钮最大值
  // const minVal = 0 // 无极旋钮最小值
  const threshold = 51 // 常规变化阈值（非边界跳变的最小差值）
  const boundaryThreshold = maxVal - threshold // 边界跳变判定阈值（约971）

  let diff = value - oldVal
  let isBoundaryJump = false // 是否为边界跳变

  // 1. 判定边界跳变：从最大值(1022)跳向最小值(0) 或 从最小值(0)跳向最大值(1022)
  if (oldVal >= boundaryThreshold && value <= threshold) {
    // 场景1：旧值接近1022，新值接近0 → 顺时针旋转（+档位）
    notch++
    isBoundaryJump = true
  } else if (oldVal <= threshold && value >= boundaryThreshold) {
    // 场景2：旧值接近0，新值接近1022 → 逆时针旋转（-档位）
    notch--
    isBoundaryJump = true
  }
  // 2. 非边界跳变：常规差值判断
  else if (Math.abs(diff) >= threshold) {
    notch += diff > 0 ? 1 : -1
  }

  // 3. 边界跳变/常规有效变化时，更新旧值
  if (isBoundaryJump || Math.abs(diff) >= threshold) {
    oldVal = value
  }

  // 4. 档位上下限限制
  notch = Math.max(-10, Math.min(10, notch))
  // console.log("🚀 ~ 1267.js:56 ~ notchToSoft ~ notch:", notch)
  // console.log("🚀 ~ 1267.js:52 ~ notchToSoft ~ oldVal:", oldVal)
  // console.log("🚀 ~ 1267.js:52 ~ notchToSoft ~ value:", value)

  return { value: notch }
}

export default {
  hardwareToSoft,
}
